import { PERIOD_TYPE } from '../constants';

const toIsoString = (value) => {
  if (!value) return undefined;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
};

export const computeStartEnd = (formValues) => {
  if (formValues.periodType === PERIOD_TYPE.RANGE) {
    return {
      start_time: toIsoString(formValues.rangeStart),
      end_time: toIsoString(formValues.rangeEnd),
    };
  }

  const start = toIsoString(formValues.singleDate);
  const durationMinutes =
    (parseInt(formValues.hours, 10) || 0) * 60 +
    (parseInt(formValues.minutes, 10) || 0);

  if (!start || !durationMinutes) {
    return { start_time: start, end_time: undefined };
  }

  const end = new Date(new Date(start).getTime() + durationMinutes * 60_000);
  return { start_time: start, end_time: end.toISOString() };
};

export const computeQuantityValue = ({ hours, minutes }) => (
  (parseInt(hours, 10) || 0) * 60 + (parseInt(minutes, 10) || 0)
);
